import { render } from "./HomeDocuments.vue?vue&type=template&id=4c5c2008&scoped=true"
import script from "./HomeDocuments.vue?vue&type=script&lang=js"
export * from "./HomeDocuments.vue?vue&type=script&lang=js"

import "./HomeDocuments.vue?vue&type=style&index=0&id=4c5c2008&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c5c2008"]])

export default __exports__